import React, { useState } from "react";
import "./Vendor_Login_Details.css";
import Common_Vendor_Login_Details from "../../../common_components/common-login-vendor-details/Common_Login_Vendor_Details";
import Vendor_Login_History_Modal from "./vendor-login-history-modal/Vendor_Login_History_Modal";
import Banner_2 from "../../../contact-us/banner_2/Banner_2";
const Data = [
  {
    id: 1,
    name: "Saurabh Dalvi",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 5479565845",
    whatsapp: "+91 5658456854",
  },
  {
    id: 2,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
  {
    id: 3,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
  {
    id: 1,
    name: "Saurabh Dalvi",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 5479565845",
    whatsapp: "+91 5658456854",
  },
  {
    id: 2,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
  {
    id: 3,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
  {
    id: 1,
    name: "Saurabh Dalvi",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 5479565845",
    whatsapp: "+91 5658456854",
  },
  {
    id: 2,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
  {
    id: 3,
    name: "Abhishek Shinde",
    material: "sand supplier",
    timeline: "3-4 days",
    experience: "6 Years",
    state: "Maharashtra",
    district: "Haveli",
    taluka: "Pune",
    area: "bavdhan",
    img: "/assets/images/house-img.png",
    mobile: "+91 9999999999",
    whatsapp: "+91 8888888888",
  },
];

const Vendor_Login_Details = () => {
  const [showLoginHistory, setShowLoginHistory] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const handleCallClick = (vendorData) => {
    setSelectedVendor(vendorData);
    setShowLoginHistory(true);
  };

  const handleCloseModal = () => {
    setShowLoginHistory(false);
    setSelectedVendor(null);
  };

  return (
    <div className="Vendor-login-section">
      <div className="container mt-4 vendor-login-section">
        <div className="row">
          {Data.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
              <Common_Vendor_Login_Details
                data={item}
                onCallClick={() => handleCallClick(item)}
              />
            </div>
          ))}
        </div>
      </div>
      <Banner_2 />

      {/* <Vendor_Login_History_Modal
                show={showLoginHistory} 
                handleClose={handleCloseModal} 
                data={selectedVendor}
            /> */}
    </div>
  );
};

export default Vendor_Login_Details;
